export default function ContactHero() {
  return (
    <header className="relative pt-32 pb-20 bg-stone-950 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20dark%20background%20with%20glowing%20warm%20amber%20and%20orange%20light%20rays%20emanating%20from%20a%20central%20point%2C%20deep%20dark%20charcoal%20black%20surface%20with%20scattered%20tiny%20light%20particles%2C%20minimal%20geometric%20lines%2C%20cinematic%20mood%2C%20no%20text%2C%20no%20people%2C%20ultra%20high%20resolution%20editorial%20photography&width=1920&height=600&seq=contact-hero-bg-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top opacity-40"
          aria-hidden="true"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-stone-950/60 via-stone-950/50 to-stone-950" />
      </div>

      <div className="relative z-10 w-full max-w-3xl mx-auto px-6 lg:px-8 text-center">
        <span className="inline-flex items-center gap-2 bg-orange-500/20 border border-orange-400/30 text-orange-300 text-xs font-bold px-4 py-1.5 rounded-full mb-8 backdrop-blur-sm uppercase tracking-widest">
          Get in Touch
        </span>
        <h1 className="text-4xl sm:text-5xl font-black text-white leading-tight tracking-tight mb-5">
          We&apos;d love to{' '}
          <span className="text-orange-400">hear from you</span>
        </h1>
        <p className="text-lg text-stone-300 max-w-xl mx-auto leading-relaxed">
          Whether you have a question about features, pricing, or just want to say hi — our team is ready to help. Most messages get a reply within a few hours.
        </p>
      </div>
    </header>
  );
}
